/**
 * Utility functions for creating boards and game states.
 */
import { PLAYER_BLACK, PLAYER_WHITE } from "@/constants";

/**
 * Returns the opposite player color.
 * @param player The current player color (PLAYER_BLACK or PLAYER_WHITE)
 * @returns The opposite player color
 */
export function getOppositePlayer(
  player: typeof PLAYER_BLACK | typeof PLAYER_WHITE
): typeof PLAYER_BLACK | typeof PLAYER_WHITE {
  return player === PLAYER_BLACK ? PLAYER_WHITE : PLAYER_BLACK;
}

// Export pip counter utility
export { calculatePipCount } from "./pipCounter";
